<sc-tile matRipple [fitHeight]="fitHeight" class="button">
    <sc-padding fitHeight>
        <sc-flex fitHeight vertical [centered]="true">
            <sc-icon iconClass="{{iconCSS}}" large></sc-icon>
            <sc-content-spacer vertical></sc-content-spacer>
            <div class="label">
              <sc-dictionary-label [dictionaryKey]="dictionaryKey"></sc-dictionary-label>
            </div>
        </sc-flex>
    </sc-padding>
</sc-tile>
